//#region src/components/ui/empty/locale/en_US.ts
var e = {
	title: "No Data",
	actionText: "Action"
};
//#endregion
export { e as emptyLocale };

//# sourceMappingURL=en_US.js.map